import e from"../utils.js";var t=e,o=function(e,o){t.forEach(e,(function(t,r){r!==o&&r.toUpperCase()===o.toUpperCase()&&(e[o]=t,delete e[r])}))};export{o as default};
